<template>
    <div class="recruit-box">
        <h3 class="caption">{{data1.caption}}</h3>
        <p class="title">{{data1.center}}</p>
        <h3 class="caption">{{data2.caption}}</h3>
        <ul class="center-ul">
            <li class="center-item-li" v-for='(item,index) in data2.center' :key='index' v-html='item'></li>
        </ul>
        <p class="title title2">{{data2.bottomTitle}}</p>
        <p class="mail">简历投递邮箱：<a href="mailto:zhenglinfei@lanjingshuzi.com?subject=我的简历&body=简历内容">{{mail}}</a></p>
    </div>
</template>
<script>
    export default {
        name: 'Recruit',
        data() {
            return {
                data1: {
                    caption: '蓝鲸人才观',
                    center: '工作必须是永远准确无误的，离开你办公桌，交到别人手里的工作成果必须是完美无缺的。所以，蓝鲸欢迎有高水平合作精神的小伙伴加盟'
                },
                data2: {
                    caption: '我们储备',
                    center: ['数字营销顾问', '项目经理', '英文文案策划', '网页设计师等'],
                    bottomTitle: '有梦想的小伙伴一起来搞点事情'
                },
                mail: 'zhenglinfei@lanjingshuzi.com'
            }
        }
    }
</script>
<style scoped>
    .recruit-box {
        min-height: 664px;
        background-color: #ffffff;
        background: #666666 url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/contcatus/%E7%BB%84%20748.jpg') no-repeat center;
        background-size: cover;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .caption {
        font-size: 24px;
        font-weight: bold;
        line-height: 137%;
        color: rgba(255, 255, 255, 1);
        margin-bottom: 22px;
    }

    .caption:last-of-type {
        margin-top: 57px;
    }

    .title {
        font-size: 18px;
        font-weight: 400;
        line-height: 200%;
        color: rgba(241, 241, 241, 1);
        text-align: center;
        max-width: 735px;
    }
    .title2{
        margin-top:10px;
    }
    .center-ul {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
    }

    .center-item-li:not(:last-of-type) {
        border-right: 1px solid #ffffff;
    }

    .center-item-li {
        font-size: 18px;
        padding: 0% 1%;
        color: rgba(255, 255, 255, 1);
        white-space: nowrap;
    }

    .mail,
    a {
        min-width: 492px;
        font-size: 24px;
        font-weight: 400;
        line-height: 200%;
        color: rgba(255, 255, 255, 1);
    }

    .mail{
        margin-top: 51px;
        border: 1px solid #ffffff;
        padding:0 1%;
    }

    @media(max-width: 995px){
        .recruit-box {
        min-height: auto;
        padding: 5%;
    }
    .caption {
        font-size: 24px;
        margin-bottom:1%;
    }
    .caption:last-of-type {
        margin-top:3%;
    }
    .title {
        font-size: 16px;
        max-width:100%;
    }
    .center-ul {
        width: 60%;
        display: grid;
        grid-template-columns: 1fr 1fr;
        justify-items: center;
        grid-row-gap: 10%;
    }
    .center-item-li {
        font-size: 16px;
        text-align: center;
        width: 100%;
    }
    .center-item-li:not(:last-of-type) {
        border-right:none;
    }
    .center-item-li:nth-child(1),.center-item-li:nth-child(3){
        border-right:1px solid #ffffff;
    }
    .mail{
        min-width: 100%;
        border: none;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    a{
        display: block;
        text-align: center;
    }
    .mail,
    a {
        
        font-size: 16px;
    }
    .mail{
        margin-top:5%;
    }
    }

    /* @media(max-width: 995px) {
        .recruit-box {
        min-height: auto;
        padding: 5% 0;
    }
        .center-ul {
            padding: 0 5%;
        }

        .center-item-li:first-child {
            font-size: 35px;
            line-height: 121%;
            margin-bottom: 1%;
        }

        .center-item-li,
        .center-item-li>>>a {
            font-size: 16px;
        }
    } */

    /* @media(max-width: 1023px) {
        .center-ul {
        max-width: 90%;
        padding: 8% 0;
    }
        .center-item-li,
        .center-item-li>>>a {
            font-size: 50px;
            font-weight: 400;
            color: #FFFFFF;
            text-align: center;
            line-height: 200%;
        }

        .center-item-li:first-child {
            font-size: 130px;
            font-family: gilroybold4;
            font-weight: bold;
            line-height: 109px;
            color: rgba(255, 255, 255, 1);
            margin-bottom: 48px;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/contact/recruit.vue